import { createActions, createReducer } from 'reduxsauce'

const { Types, Creators } = createActions({
  fetchPublicStatsRequest: null,
  fetchPublicStatsSuccess: ['data'],
  fetchPublicStatsFailure: ['error'],
})

export const StatsTypes = Types
export const StatsActions = Creators

const INITIAL_STATE = {
  publicStatsLoading: false,
  publicStats: null,
  publicStatsError: null,
}

const fetchPublicStatsRequest = (state) => ({
  ...state,
  publicStatsLoading: true,
  publicStatsError: null,
})

const fetchPublicStatsSuccess = (state, action) => ({
  ...state,
  publicStatsLoading: false,
  publicStats: action.data,
  publicStatsError: null,
})

const fetchPublicStatsFailure = (state, action) => ({
  ...state,
  publicStatsLoading: false,
  publicStatsError: action.error,
})

export default createReducer(INITIAL_STATE, {
  [Types.FETCH_PUBLIC_STATS_REQUEST]: fetchPublicStatsRequest,
  [Types.FETCH_PUBLIC_STATS_SUCCESS]: fetchPublicStatsSuccess,
  [Types.FETCH_PUBLIC_STATS_FAILURE]: fetchPublicStatsFailure,
})
